/* Revele les elements [data-vd-reveal] a leur entree dans le viewport.
   L'etat masque est pose ici et pas dans le CSS de base : si ce fichier ne
   charge pas, ou si le visiteur prefere le mouvement reduit, rien n'est
   jamais cache. Chaque element ne joue qu'une fois (unobserve), et le
   decalage en cascade reste limite au groupe de cartes, plafonne. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var cibles = document.querySelectorAll('[data-vd-reveal]');
  if (!cibles.length) return;

  var observateur = new IntersectionObserver(
    function (entrees) {
      entrees.forEach(function (entree) {
        /* Un element deja passe au-dessus du viewport (defilement rapide,
           ancre, retour arriere) ne recroisera jamais le seuil : il est
           revele aussi, sinon il reste invisible tant que la page vit. */
        var depasse = entree.boundingClientRect.bottom < 0;
        if (!entree.isIntersecting && !depasse) return;
        entree.target.classList.add('est-revele');
        observateur.unobserve(entree.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
  );

  var parIndex = {};
  cibles.forEach(function (element) {
    var groupe = element.getAttribute('data-vd-reveal');
    if (groupe) {
      var index = parIndex[groupe] || 0;
      parIndex[groupe] = index + 1;
      element.style.setProperty('--reveal-delai', Math.min(index * 45, 180) + 'ms');
    }
    element.classList.add('a-reveler');
    observateur.observe(element);
  });
})();
